import { RiskConfig } from './types'

// 0-40% of credit limit used -> safe · 41-80% -> medium · 81%+ -> risk
export function getRiskConfig(percentUsed: number): RiskConfig {
    if (percentUsed <= 40) {
        return {
            level: 'safe',
            badgeLabel: 'Safe',
            badgeText: 'text-emerald-600',
            badgeBg: 'bg-emerald-50',
            panelBg: 'bg-emerald-50',
            panelBorder: 'border-emerald-100',
            panelHeading: 'This order is within a safe credit range',
            panelHeadingText: 'text-emerald-700',
            dividerColor: 'bg-emerald-100',
            showApprovalWarning: false,
        }
    }
    if (percentUsed <= 80) {
        return {
            level: 'medium',
            badgeLabel: 'Medium risk',
            badgeText: 'text-amber-600',
            badgeBg: 'bg-amber-50',
            panelBg: 'bg-amber-50',
            panelBorder: 'border-amber-100',
            panelHeading: 'This order is nearing the credit limit',
            panelHeadingText: 'text-amber-700',
            dividerColor: 'bg-amber-100',
            showApprovalWarning: false,
        }
    }
    return {
        level: 'risk',
        badgeLabel: 'High risk',
        badgeText: 'text-red-600',
        badgeBg: 'bg-red-50',
        panelBg: 'bg-red-50',
        panelBorder: 'border-red-100',
        panelHeading: 'This order will exceed the credit limit',
        panelHeadingText: 'text-red-700',
        dividerColor: 'bg-red-100',
        showApprovalWarning: true,
    }
}

export function buildFallbackMessage(
    channel: 'whatsapp' | 'sms' | 'email',
    order: { id: string; customerName: string; amount: number; currency: string },
): string {
    const { customerName, id, amount, currency } = order
    if (channel === 'sms') {
        return `Majlis: Order #${id} (${amount.toFixed(2)} ${currency}) is pending admin approval as it exceeds your credit limit. We'll notify you once approved.`
    }
    if (channel === 'email') {
        return `Subject: Order #${id} pending approval\n\nDear ${customerName},\n\nYour order #${id} for ${amount.toFixed(2)} ${currency} is pending admin approval as it will exceed your credit limit. We will notify you once it is approved.\n\nThank you,\nMajlis Finance Team`
    }
    return `Dear ${customerName},\nYour order #${id} for ${amount.toFixed(2)} ${currency} is pending admin approval as it will exceed your credit limit.\nWe will notify you once it is approved.\nThank you.`
}
